const defaultState = {
    siteDocument: {},
};

const mutations = {
    setSiteDocument(state, siteDocument) {
        state.siteDocument = siteDocument;
    },
    resetSiteDocument(state) {
        state.siteDocument = {};
    },
};

const actions = {
    async getSiteDocument({ commit, dispatch }, { siteId, documentId }) {
        try {
            const { data } = await this.$rq.getSiteDocument(siteId, documentId);
            commit('setSiteDocument', data);
        } catch (err) {
            dispatch('resetSiteDocument');
        }
    },
    resetSiteDocument({ commit }) {
        commit('resetSiteDocument');
    },
};

const getters = {
    siteDocument: ({ siteDocument }) => siteDocument,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
